import { api } from '../client'
import type { RequestOptions } from '../client'
import type { SavedFilter, SavedFilterInput } from './types'

export const savedFiltersHttpApi = {
  list: (options?: RequestOptions): Promise<SavedFilter[]> =>
    api.get<SavedFilter[]>('/saved-filters', options),

  create: (input: SavedFilterInput): Promise<SavedFilter> =>
    api.post<SavedFilter>('/saved-filters', input),

  remove: (id: number): Promise<void> => api.del<void>(`/saved-filters/${id}`),
}
